export default __webpack_public_path__ + "img/minus.45993ac7.svg";